export const WATERFALL_FETCH_TRACKS = 'WATERFALL_FETCH_TRACKS';
export const WATERFALL_FETCH_MODELS = 'WATERFALL_FETCH_MODELS';
export const WATERFALL_FETCH_ASSUMPTIONS = 'WATERFALL_FETCH_ASSUMPTIONS';
export const WATERFALL_FETCH_VECTORS = 'WATERFALL_FETCH_VECTORS';
